import { Button } from '@mui/material';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { ContractPreview } from '../hooks/useContracts';
import { useJoinOrCreateChat } from '../hooks/useJoinOrCreateChat';
import { RoutePaths } from '../routes/AppRoutes';
import { KheopsButtonVariant } from '../providers/CustomThemeProvider';

export const resumeNegotiationButtonClassName = 'ResumeNegotiationButton';

export interface ResumeNegotiationButtonProps {
  contract: ContractPreview;
  actionName?: string;
  startIcon?: React.JSX.Element;
  buttonVariant?: KheopsButtonVariant;
}

export default function ResumeNegotiationButton({
  contract,
  actionName = 'contracts:resume_negociation',
  startIcon = <SendOutlinedIcon />,
  buttonVariant = 'contained',
}: ResumeNegotiationButtonProps): React.JSX.Element {
  const { t } = useTranslation(['contracts']);
  const { joinOrCreateChat, loading, channelUrl } = useJoinOrCreateChat();
  const navigate = useNavigate();

  useEffect((): void => {
    if (channelUrl) {
      navigate(`${RoutePaths.CHAT_LIST}?channelUrl=${channelUrl}`);
    }

  }, [channelUrl]);

  return (
    <Button
      className={resumeNegotiationButtonClassName}
      loading={loading}
      onClick={() => joinOrCreateChat(contract)}
      variant={buttonVariant}
      startIcon={startIcon}
    >
      {t(actionName)}
    </Button>
  );
}
